import THEME from "../../../theme";
import { fs } from "../utils/styles";

const geld = (n) => n == null ? "–" : `${n >= 0 ? "+" : ""}${n.toFixed(2)} €`;

function letzterEintrag(serie) {
  if (!serie) return null;
  for (let i = serie.werte.length - 1; i >= 0; i--) {
    if (serie.werte[i] != null) return { wert: serie.werte[i], index: i };
  }
  return null;
}

// Findet den Index desselben Kalendermonats im Vorjahr (z.B. "06/2025" fuer "06/2026") -
// funktioniert unabhaengig davon, ob dieser Monat tatsaechlich hochgeladen wurde.
function vorjahresIndex(monate, index) {
  const [monat, jahr] = monate[index].split("/");
  const ziel = `${monat}/${parseInt(jahr, 10) - 1}`;
  const idx = monate.indexOf(ziel);
  return idx === -1 ? null : idx;
}

function KpiKarte({ label, schluessel, trend, kostenart }) {
  const serie = trend.serien[schluessel];
  const letzter = letzterEintrag(serie);
  if (!letzter) return null;
  const { wert, index } = letzter;
  const vormonat = index > 0 ? serie.werte[index - 1] : null;
  const vjIndex = vorjahresIndex(trend.monate, index);
  const vorjahr = vjIndex != null ? serie.werte[vjIndex] : null;
  const deltaMonat = vormonat != null ? wert - vormonat : null;
  const deltaJahr = vorjahr != null ? wert - vorjahr : null;
  // Bei Kostenarten ist ein Rueckgang positiv zu werten (gruen), sonst umgekehrt.
  const farbe = (delta) => delta == null ? THEME.colors.textMuted : (kostenart ? delta <= 0 : delta >= 0) ? THEME.colors.success : THEME.colors.danger;

  return (
    <div style={{ ...fs.karte, marginBottom: 0 }}>
      <p style={{ color: THEME.colors.textMuted, fontSize: THEME.fontSize.sm, margin: "0 0 6px" }}>{label} ({trend.monate[index]})</p>
      <p style={{ color: THEME.colors.text, fontSize: THEME.fontSize.xxl, fontWeight: 700, margin: "0 0 10px" }}>{wert.toFixed(2)} €</p>
      <p style={{ margin: "0 0 2px", fontSize: THEME.fontSize.sm, color: THEME.colors.textMuted }}>
        Vormonat: <span style={{ color: farbe(deltaMonat), fontWeight: 600 }}>{geld(deltaMonat)}</span>
      </p>
      <p style={{ margin: 0, fontSize: THEME.fontSize.sm, color: THEME.colors.textMuted }}>
        Vorjahresmonat: <span style={{ color: farbe(deltaJahr), fontWeight: 600 }}>{vjIndex == null ? "– (kein Vorjahresmonat)" : geld(deltaJahr)}</span>
      </p>
    </div>
  );
}

export default function BwaJahresKpiKarten({ trend }) {
  if (!trend || !trend.monate || trend.monate.length === 0) return null;
  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(230px, 1fr))", gap: 16, marginBottom: 20 }}>
      <KpiKarte label="Umsatz" schluessel="umsatzerloese" trend={trend} />
      <KpiKarte label="Gesamtkosten" schluessel="gesamtkosten" trend={trend} kostenart />
      <KpiKarte label="Betriebsergebnis" schluessel="betriebsergebnis" trend={trend} />
      <KpiKarte label="Ergebnis vor Steuern" schluessel="ergebnis_vor_steuern" trend={trend} />
    </div>
  );
}
